import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const heroImages = [
  {
    src: '/ctg-atardecer.webp',
    position: 'center'
  },
  {
    src: 'https://images.unsplash.com/photo-1672851612770-f969b3efc02d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxDb2xvbWJpYSUyMHZpYnJhbnQlMjBjb2xvcmZ1bCUyMGxhbmRzY2FwZSUyMGx1eHVyeSUyMHRyYXZlbCUyMENvY29yYSUyMHZhbGxleXxlbnwwfHx8fDE3ODExMTg4OTF8MA&ixlib=rb-4.1.0&q=85',
    position: 'center'
  },
  {
    src: 'https://images.unsplash.com/photo-1560242374-ca6dd3434522?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxDYXJ0YWdlbmElMjBDb2xvbWJpYSUyMGNvbG9yZnVsJTIwY29sb25pYWwlMjBidWlsZGluZ3MlMjBzdW5zZXQlMjBsdXh1cnl8ZW58MHx8fHwxNzgxMTE4ODkxfDA&ixlib=rb-4.1.0&q=85',
    position: 'center'
  },
  {
    src: 'https://images.unsplash.com/photo-1631134942435-448dbf07a42a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxDb2xvbWJpYSUyMHZpYnJhbnQlMjBjb2xvcmZ1bCUyMGxhbmRzY2FwZSUyMGx1eHVyeSUyMHRyYXZlbCUyMENvY29yYSUyMHZhbGxleXxlbnwwfHx8fDE3ODExMTg4OTF8MA&ixlib=rb-4.1.0&q=85',
    position: 'center'
  }
];

const Hero = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const { t } = useLanguage();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      id="hero"
      className="relative min-h-[90vh] h-screen w-full flex flex-col items-center justify-center text-center overflow-hidden bg-[#1A2B3C]"
      data-testid="hero-section"
    >
      {/* Layered crossfade slides */}
      {heroImages.map((img, idx) => (
        <div
          key={img.src}
          className="absolute inset-0 z-0 transition-opacity ease-in-out"
          style={{
            opacity: idx === currentImage ? 1 : 0,
            transitionDuration: '1500ms'
          }}
        >
          <img
            src={img.src}
            alt="Colombia landscape"
            className="w-full h-full object-cover"
            style={{ objectPosition: img.position }}
          />
        </div>
      ))}

      {/* Soft dark overlay */}
      <div className="absolute inset-0 z-[1] bg-black/25 pointer-events-none" />

      <div className="relative z-10 flex flex-col items-center justify-center gap-8 px-6">
        <motion.img
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          src="https://customer-assets.emergentagent.com/job_ee79464f-2c92-4466-93ae-47cdcabd0920/artifacts/it9pmzym_Logo%20blanco.png"
          alt="Inaluna Destination Logo"
          className="w-72 md:w-[450px] drop-shadow-2xl"
          data-testid="hero-logo"
        />
      </div>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-[#D4C2A1] text-2xl md:text-3xl italic tracking-wider whitespace-nowrap px-4"
        data-testid="hero-tagline"
      >
        {t('hero_tagline')}
      </motion.p>
    </section>
  );
};

export default Hero;
